import Vue from "vue";
import axios from "axios";

import { Notification, MessageBox, Message } from "element-ui";
import router from "../router";
// 第三方插件
import "element-ui/lib/theme-chalk/index.css";

Vue.prototype.$axios = axios;
// 字体图标

const service = axios.create({
	baseURL: (Vue.prototype.BASE_URL),
	timeout: 50000,
	contentType: "application/x-www-form-urlencoded"
});

service.defaults.withCredentials = true; // 让ajax携带cookie
service.interceptors.request.use(
	// 每次请求都自动携带Cookie
	config => {
		let  user = JSON.parse(localStorage.getItem("user"));
		// 跨系统免登换票（sys/auth/ssoLogin）必须裸请求：过滤器只要看到 token+userId 就强制走
		// Redis 校验，带着已失效的旧 token 调换票接口会被直接 401「登陆失效」，白名单不生效。
		if ((user!=null && user.token != null)
			&& (config.url!=='sys/auth/getLoginToken' && config.url!=='sys/auth/ssoLogin')) {
			config.headers['token'] = user.token;
			config.headers['userId'] = user.id;
		}
		return config;
	},
	error => {
		console.log(error)
		return Promise.reject(error);
	}
);

service.interceptors.response.use((val) => val, (err) => {
		// 兼容无response的情况（如网络错误）
		if (!err?.response) {
			return Promise.reject(err);
		}
		switch (err.response.status) {
			case 400:
				debounceNotice('400', () => {
					Notification.error({ title: "提醒", message: err.response.data });
				});
				break;
			case 401:
				debounceNotice('401', () => {
					Notification.error({ title: "提醒", message: "登陆已过期！" });
					localStorage.removeItem("user");
					router.replace('/login');
				});
				break;
			case 403:
				debounceNotice('403', () => {
					Message.warning("抱歉，您无权访问！");
				});
				break;
			case 500:
				debounceNotice('500', () => {
					Notification.error({ title: "提醒", message: "服务器出了点小错误" });
				});
				break;
			case 404:
				debounceNotice('404', () => {
					Notification({ title: "提醒", message: "未找到，检查参数", type: "warning" });
				});
				break;
			default:
				// 非上述状态不做防抖，直接reject
				return Promise.reject(err);
		}
		return Promise.reject(err);
	}
);
// 缓存：记录最近一次各类型提醒的触发时间 { [type: string]: number }
const noticeCache = {};
// 防抖间隔：3秒（可根据需求调整）
const DEBOUNCE_TIME = 3000;

// 封装防抖提醒函数
const debounceNotice = (type, noticeFn) => {
	// 校验缓存：如果该类型3秒内已触发过，直接返回
	if (noticeCache[type] && Date.now() - noticeCache[type] < DEBOUNCE_TIME) {
		return;
	}
	// 更新缓存：记录当前触发时间
	noticeCache[type] = Date.now();
	// 执行提醒逻辑
	noticeFn();
};
export default service;








